(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3342],{

/***/ 26951:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vem-ser-hype",
      function () {
        return __webpack_require__(53403);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37265);
/* harmony import */ var _bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67202);
/* harmony import */ var _bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function Banner(param) {
    var image = param.image, _children = param.children, children = _children === void 0 ? "" : _children, _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? "fit-content" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bannerContainer),
        style: {
            width: width,
            height: height
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: (image === null || image === void 0 ? void 0 : image.src) || "/img/loading-wall.gif",
                loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__/* .customLoader */ .l,
                width: width,
                layout: "fill",
                objectFit: "cover",
                quality: 100,
                alt: "Hype Empreendimentos",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default().childrenContainer),
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 38280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function MetaTags(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    if (!data) return null;
    var ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, _descricao, ref21, ref22;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    " ",
                    (ref8 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref8 !== void 0 ? ref8 : "",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: (ref9 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref9 !== void 0 ? ref9 : ""
            }, "metadescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "name",
                content: (ref10 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref10 !== void 0 ? ref10 : ""
            }, "googlename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "description",
                content: (ref11 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref11 !== void 0 ? ref11 : ""
            }, "googledescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: (ref12 = data === null || data === void 0 ? void 0 : (ref = data.imagem) === null || ref === void 0 ? void 0 : ref.url) !== null && ref12 !== void 0 ? ref12 : ""
            }, "googleimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (ref13 = data === null || data === void 0 ? void 0 : data.rota) !== null && ref13 !== void 0 ? ref13 : ""
            }, "ogurl"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "ogtype"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: (ref14 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref14 !== void 0 ? ref14 : ""
            }, "ogtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: (ref15 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref15 !== void 0 ? ref15 : ""
            }, "ogdesc"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: (ref16 = data === null || data === void 0 ? void 0 : (ref1 = data.imagem) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref16 !== void 0 ? ref16 : ""
            }, "image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                itemProp: "image",
                content: (ref17 = data === null || data === void 0 ? void 0 : (ref2 = data.imagem) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref17 !== void 0 ? ref17 : ""
            }, "ogimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: (ref18 = data === null || data === void 0 ? void 0 : (ref3 = data.imagem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.width) === null || ref4 === void 0 ? void 0 : ref4.toString()) !== null && ref18 !== void 0 ? ref18 : ""
            }, "ogimagewidth"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: (ref19 = data === null || data === void 0 ? void 0 : (ref5 = data.imagem) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.height) === null || ref6 === void 0 ? void 0 : ref6.toString()) !== null && ref19 !== void 0 ? ref19 : ""
            }, "ogimageheight"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Hype Empreendimentos"
            }, "ogsitename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: (ref20 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref20 !== void 0 ? ref20 : ""
            }, "twittertitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: (_descricao = data.descricao) !== null && _descricao !== void 0 ? _descricao : ""
            }, "twitterdescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: (ref21 = data === null || data === void 0 ? void 0 : (ref7 = data.imagem) === null || ref7 === void 0 ? void 0 : ref7.url) !== null && ref21 !== void 0 ? ref21 : ""
            }, "twitterimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:domain",
                content: "hypeempreendimentos.com.br"
            }, "twitterdomain"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: (ref22 = data === null || data === void 0 ? void 0 : data.rota) !== null && ref22 !== void 0 ? ref22 : ""
            }, "twitterurl")
        ]
    });
}


/***/ }),

/***/ 53403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50121);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38280);
/* harmony import */ var _utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34873);
/* harmony import */ var _nosMove__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92940);
/* harmony import */ var _paraNos__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30162);
/* harmony import */ var _somos__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90444);
/* harmony import */ var _transparencia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75785);










var __N_SSG = true;
function Index(param) {
    var vemSerHype = param.vemSerHype;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var rota = "https://hypeempreendimentos.com.br".concat(router.asPath);
    if (!vemSerHype) return null;
    var textos = vemSerHype.textos, imagens = vemSerHype.imagens;
    var listas = (ref1 = vemSerHype === null || vemSerHype === void 0 ? void 0 : (ref = vemSerHype.listas) === null || ref === void 0 ? void 0 : ref.find(function(lt) {
        return lt.referencia === "o-que-nos-move";
    })) === null || ref1 === void 0 ? void 0 : ref1.lista.itens;
    var listaOqueNosMove = [];
    var iconesOqueNosMove = imagens.filter(function(img) {
        return img.referencia.includes("icone");
    });
    for(var i = 0; i < listas.length; i += 1){
        listaOqueNosMove.push({
            icone: iconesOqueNosMove[i].imagem.url,
            titulo: listas[i].item,
            texto: listas[i].descricao
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    data: {
                        titulo: vemSerHype === null || vemSerHype === void 0 ? void 0 : (ref2 = vemSerHype.seo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.seo) === null || ref3 === void 0 ? void 0 : ref3.metaTitle,
                        descricao: vemSerHype === null || vemSerHype === void 0 ? void 0 : (ref4 = vemSerHype.seo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.seo) === null || ref5 === void 0 ? void 0 : ref5.metaDescription,
                        imagem: vemSerHype === null || vemSerHype === void 0 ? void 0 : (ref6 = vemSerHype.seo) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.seo) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.ogImage) === null || ref8 === void 0 ? void 0 : ref8.url,
                        rota: rota
                    }
                })
            }),
            imagens.find(function(img) {
                return img.referencia === "banner-vem-ser-hype";
            }) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                image: {
                    src: (0,_utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_9__/* .imagemSizes */ .xQ)((0,_utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_9__/* .findImage */ .jw)(imagens === null || imagens === void 0 ? void 0 : imagens.imagens, "banner-vem-ser-hype"))
                },
                width: "100%",
                height: "70vh",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    style: {
                        color: "#FFFCF5"
                    },
                    children: (ref9 = textos === null || textos === void 0 ? void 0 : textos.find(function(txt) {
                        return txt.referencia === "banner-principal-titulo";
                    })) === null || ref9 === void 0 ? void 0 : ref9.texto.conteudo
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    width: "100%",
                    height: "70vh",
                    textAlign: "center",
                    paddingTop: "35vh",
                    background: "#222E4C"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    style: {
                        color: "#FFFCF5"
                    },
                    children: (ref10 = textos === null || textos === void 0 ? void 0 : textos.find(function(txt) {
                        return txt.referencia === "banner-principal-titulo";
                    })) === null || ref10 === void 0 ? void 0 : ref10.texto.conteudo
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_somos__WEBPACK_IMPORTED_MODULE_7__["default"], {
                dados: {
                    banner: (ref11 = imagens === null || imagens === void 0 ? void 0 : imagens.find(function(img) {
                        return img.referencia === "vem-ser-hype-somos";
                    })) === null || ref11 === void 0 ? void 0 : ref11.imagem.url,
                    titulo: (ref12 = textos === null || textos === void 0 ? void 0 : textos.find(function(txt) {
                        return txt.referencia === "vem-ser-hype-somos-titulo";
                    })) === null || ref12 === void 0 ? void 0 : ref12.texto.conteudo,
                    texto: (ref13 = textos === null || textos === void 0 ? void 0 : textos.find(function(txt) {
                        return txt.referencia === "vem-ser-hype-somos-texto";
                    })) === null || ref13 === void 0 ? void 0 : ref13.texto.conteudo
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_paraNos__WEBPACK_IMPORTED_MODULE_6__["default"], {
                image: {
                    height: (ref14 = imagens === null || imagens === void 0 ? void 0 : imagens.find(function(img) {
                        return img.referencia === "vem-ser-hype-paranos";
                    })) === null || ref14 === void 0 ? void 0 : ref14.imagem.height,
                    url: (ref15 = imagens === null || imagens === void 0 ? void 0 : imagens.find(function(img) {
                        return img.referencia === "vem-ser-hype-paranos";
                    })) === null || ref15 === void 0 ? void 0 : ref15.imagem.url,
                    width: (ref16 = imagens === null || imagens === void 0 ? void 0 : imagens.find(function(img) {
                        return img.referencia === "vem-ser-hype-paranos";
                    })) === null || ref16 === void 0 ? void 0 : ref16.imagem.width
                },
                text: (ref17 = textos === null || textos === void 0 ? void 0 : textos.find(function(txt) {
                    return txt.referencia === "vem-ser-hype-paranos-texto";
                })) === null || ref17 === void 0 ? void 0 : ref17.texto.conteudo,
                title: (ref18 = textos === null || textos === void 0 ? void 0 : textos.find(function(txt) {
                    return txt.referencia === "vem-ser-hype-paranos-titulo";
                })) === null || ref18 === void 0 ? void 0 : ref18.texto.conteudo
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nosMove__WEBPACK_IMPORTED_MODULE_5__["default"], {
                dados: {
                    lista: listaOqueNosMove,
                    titulo: (ref19 = textos === null || textos === void 0 ? void 0 : textos.find(function(txt) {
                        return txt.referencia === "nos-move-titulo";
                    })) === null || ref19 === void 0 ? void 0 : ref19.texto.conteudo
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_transparencia__WEBPACK_IMPORTED_MODULE_8__["default"], {})
        ]
    });
}


/***/ }),

/***/ 92940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NosMove; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37265);
/* harmony import */ var _nosMove_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48733);
/* harmony import */ var _nosMove_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_nosMove_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var parse = __webpack_require__(30488);
function NosMove(param) {
    var dados = param.dados;
    if (!dados) return null;
    var titulo = dados.titulo, lista = dados.lista;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_nosMove_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_nosMove_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: titulo && parse(titulo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_nosMove_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cards),
                children: lista && lista.map(function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_nosMove_module_scss__WEBPACK_IMPORTED_MODULE_2___default().card),
                        children: [
                            item.icone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                src: item.icone || "/img/image_icon.png",
                                loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_3__/* .customLoader */ .l,
                                alt: "",
                                width: 65,
                                height: 65
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: parse(item.titulo)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: parse(item.texto)
                            })
                        ]
                    }, item.titulo);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_nosMove_module_scss__WEBPACK_IMPORTED_MODULE_2___default().buttons),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_nosMove_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerButton),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            href: "https://vemserhype.gupy.io/",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                "aria-label": "Conhe\xe7a as vagas dispon\xedveis",
                                type: "button",
                                tabIndex: -1,
                                children: "Conhe\xe7a as vagas dispon\xedveis!"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_nosMove_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerButton),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            href: "https://www.instagram.com/hype_empreendimentos/",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                "aria-label": "Conhe\xe7a as vagas dispon\xedveis",
                                type: "button",
                                tabIndex: -1,
                                style: {
                                    background: "radial-gradient(circle farthest-corner at 35% 90%, #fec564, transparent 50%), radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%), radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 20% -50%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 60% -20%, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent), linear-gradient(#6559ca, #bc318f 30%, #e33f5f 50%, #f77638 70%, #fec66d 100%)"
                                },
                                children: "Nos siga no Instagram!"
                            })
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 30162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50121);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37265);
/* harmony import */ var _paraNos_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59238);
/* harmony import */ var _paraNos_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_paraNos_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var parse = __webpack_require__(30488);
function Paranos(param) {
    var image = param.image, title = param.title, text = param.text;
    if (!image) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        image: {
            src: "/img/backgroundpolitica.webp"
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_paraNos_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                    className: (_paraNos_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imageContainer),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            alt: "Background: Extraordin\xe1rio \xe9 necess\xe1rio",
                            src: image.url || "/img/image_icon.png",
                            loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__/* .customLoader */ .l,
                            layout: "responsive",
                            width: image.width,
                            height: image.height,
                            priority: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                            children: "Background: Extraordin\xe1rio \xe9 necess\xe1rio"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_paraNos_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: title && parse(title)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: text && parse(text)
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Paranos);


/***/ }),

/***/ 90444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Somos; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50121);
/* harmony import */ var _somos_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90737);
/* harmony import */ var _somos_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_somos_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var parse = __webpack_require__(30488);
function Somos(param) {
    var dados = param.dados;
    if (!dados) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        image: {
            src: dados.banner
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_somos_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: parse(dados.texto)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: parse(dados.titulo)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: parse(dados.titulo)
                })
            ]
        })
    });
}


/***/ }),

/***/ 75785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Transparencia; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _transparencia_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23962);
/* harmony import */ var _transparencia_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_transparencia_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Transparencia() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_transparencia_module_scss__WEBPACK_IMPORTED_MODULE_1___default().section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_transparencia_module_scss__WEBPACK_IMPORTED_MODULE_1___default().title),
                children: "Relat\xf3rio de Transpar\xeancia e Igualdade Salarial de Mulheres e Homens"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_transparencia_module_scss__WEBPACK_IMPORTED_MODULE_1___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Este \xe9 o relat\xf3rio de transpar\xeancia salarial, elaborado e disponibilizado pelo Minist\xe9rio do Trabalho e Emprego, que disp\xf5e sobre a igualdade salarial e de crit\xe9rios remunerat\xf3rios entre homens e mulheres."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://portal-bucket.azureedge.net/wp-content/2024/03/Relatorio_da_transparencia.pdf",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: (_transparencia_module_scss__WEBPACK_IMPORTED_MODULE_1___default().button),
                            type: "button",
                            children: "Acessar o Relat\xf3rio"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        style: {},
                        children: "Fonte: eSocial. Rais 2022 e Portal Emprega Brasil (mar\xe7o de 2024)"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 34873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jw": function() { return /* binding */ findImage; },
/* harmony export */   "xQ": function() { return /* binding */ imagemSizes; }
/* harmony export */ });
/* unused harmony export imagemSizeDestructure */
// eslint-disable-next-line import/prefer-default-export
var imagemSizeDestructure = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = props === null || props === void 0 ? void 0 : props.imagem;
    if (data === null || data === void 0 ? void 0 : (ref = data.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return data.sizes.large;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.sizes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.medium) === null || ref3 === void 0 ? void 0 : ref3.url) {
        return data.sizes.medium;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) {
        return data.sizes.small;
    }
    if (data === null || data === void 0 ? void 0 : (ref6 = data.sizes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.square) === null || ref7 === void 0 ? void 0 : ref7.url) {
        return data.sizes.square;
    }
    if (data === null || data === void 0 ? void 0 : (ref8 = data.sizes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url) {
        return data.sizes.thumbnail;
    }
    if (data === null || data === void 0 ? void 0 : data.url) {
        return data;
    }
    return "";
};
var imagemSizes = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = props === null || props === void 0 ? void 0 : props.imagem;
    if (data === null || data === void 0 ? void 0 : (ref = data.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return data.sizes.large.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.sizes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.medium) === null || ref3 === void 0 ? void 0 : ref3.url) {
        return data.sizes.medium.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) {
        return data.sizes.small.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref6 = data.sizes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.square) === null || ref7 === void 0 ? void 0 : ref7.url) {
        return data.sizes.square.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref8 = data.sizes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url) {
        return data.sizes.thumbnail.url;
    }
    if (data === null || data === void 0 ? void 0 : data.url) {
        return data.url;
    }
    return "";
};
var findImage = function(imagens, referencia) {
    return imagens === null || imagens === void 0 ? void 0 : imagens.find(function(img) {
        return img.referencia === referencia;
    });
};


/***/ }),

/***/ 67202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"bannerDefault_bannerContainer___FPrj","childrenContainer":"bannerDefault_childrenContainer__kGyT8"};

/***/ }),

/***/ 48733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"nosMove_section__UnZY8","buttons":"nosMove_buttons__FvY5N","containerButton":"nosMove_containerButton__m8TFG","cards":"nosMove_cards__cL7va","card":"nosMove_card__X_Wwh"};

/***/ }),

/***/ 59238:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"paraNos_section__SYWXJ","imageContainer":"paraNos_imageContainer__S_Nf0","content":"paraNos_content__cbkmA"};

/***/ }),

/***/ 90737:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"somos_text__nk7TF"};

/***/ }),

/***/ 23962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"transparencia_section__Y24Yk","content":"transparencia_content__OPhs3"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(26951); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);